import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/marketing/email-templates")({
  beforeLoad: requirePermissionGuard("hca.email_serialy.write"),
});
